import { debugWarn } from "../../utils/debugLog";

const CHUNK_RECOVERY_STORAGE_KEY = "eruption:chunk-recovery:lastReloadAt";
const CHUNK_RECOVERY_WINDOW_MS = 5 * 60 * 1000;

export const isLikelyChunkLoadError = (error: unknown): boolean => {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === "string"
        ? error
        : JSON.stringify(error);

  return /ChunkLoadError|Loading chunk \\d+ failed|Unexpected token '<'/i.test(
    message ?? ""
  );
};

export const attemptChunkLoadRecovery = (
  error: unknown,
  options: { force?: boolean } = {}
): boolean => {
  if (typeof window === "undefined" || typeof sessionStorage === "undefined") {
    return false;
  }

  if (!isLikelyChunkLoadError(error)) {
    return false;
  }

  const now = Date.now();
  const lastRaw = sessionStorage.getItem(CHUNK_RECOVERY_STORAGE_KEY);
  const lastReloadAt = lastRaw ? Number(lastRaw) : 0;
  const withinWindow =
    Number.isFinite(lastReloadAt) && now - lastReloadAt < CHUNK_RECOVERY_WINDOW_MS;

  if (withinWindow && !options.force) {
    return false;
  }

  sessionStorage.setItem(CHUNK_RECOVERY_STORAGE_KEY, String(now));
  debugWarn?.(
    "🔄 Detected chunk load error; reloading to fetch latest build.",
    error
  );
  window.location.reload();
  return true;
};

